import * as React from "react";
import { ConfirmModal } from "./ConfirmModal";
import { InformationModal } from "./InformationModal";
import { Intent, Modal } from "../../index";

/**
 * Zobrazi v modalnim okne potvrzovaci dialog.
 *
 * @param message Text dialogu (callback)
 * @param intent Intent dialogu
 * @param confirmButtonTitle Text potvrzovaciho tlacitka
 * @param cancelButtonTitle Text odmitavaciho tlacitka
 * @return Promise<boolean> Vraci true pokud uzivatel potvrdi, false pokud odmitne
 */
export const showConfirmation = (
    message: () => React.ReactNode,
    intent: Intent = Intent.PRIMARY,
    confirmButtonTitle: string = "Ano",
    cancelButtonTitle: string = "Ne",
): Promise<boolean> => {
    return new Promise<boolean>(resolve => {
        Modal.show(() => (
            <ConfirmModal
                message={message()}
                intent={intent}
                onConfirm={() => {
                    Modal.hide();
                    resolve(true);
                }}
                onCancel={() => {
                    Modal.hide();
                    resolve(false);
                }}
                confirmButtonTitle={confirmButtonTitle}
                cancelButtonTitle={cancelButtonTitle}
            />
        ));
    });
};

/**
 * Zobrazi v modalnim okne informacni dialog.
 *
 * @param message Text dialogu (callback)
 * @param intent Intent dialogu
 * @return Promise<void> Vraci promise
 */
export const showInformation = (message: () => React.ReactNode, intent: Intent = Intent.PRIMARY): Promise<void> => {
    return new Promise<void>(resolve => {
        Modal.show(() => (
            <InformationModal
                message={message()}
                intent={intent}
                onClose={() => {
                    Modal.hide();
                    resolve();
                }}
            />
        ));
    });
};
